var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 0H1.8C0.8 0 0 0.803347 0 1.70711V22.2929C0 23.1967 0.8 24 1.8 24H22.2C23.2 24 24 23.1967 24 22.2929V1.70711C24 0.803347 23.2 0 22.2 0ZM7.1 20.4854H3.6V9.03766H7.1V20.4854ZM5.4 7.43096C4.3 7.43096 3.3 6.5272 3.3 5.32218C3.3 4.11716 4.2 3.21339 5.4 3.21339C6.5 3.21339 7.5 4.11716 7.5 5.32218C7.5 6.5272 6.5 7.43096 5.4 7.43096ZM20.5 20.3849H17V14.7615C17 13.4561 17 11.6485 15.1 11.6485C13.2 11.6485 13 13.1548 13 14.5607V20.2845H9.5V9.03766H12.8V10.5439H12.9C13.4 9.64017 14.6 8.63598 16.3 8.63598C19.9 8.63598 20.6 11.046 20.6 14.159V20.3849H20.5Z",
    fill: "#2E54C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.5fada90e8bbe2dbeacbf1dd2fcd5497f.svg";
export { ForwardRef as ReactComponent };